import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

import OperatorStatus from "../OperatorStatus/OperatorStatus";
import PhoneIcon from "../../assets/img/black-phone.svg";
import OperatorIcon from "../../assets/img/avatar.png";
import { blueLink } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  img: {
    height: "100%",
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  telLink: {
    display: "flex",
    alignItems: "center",
    "& img": {
      marginRight: "4px",
    },
  },
  blueLink: {
    "& p": {
      color: blueLink,
    },
  },
  mainStyles: (props) => ({
    [down("sm")]: {
      display: props.showOnMobile ? "block" : "none",
    },
  }),
}));

const FormOperator = ({ operatorInfo, quoteUnavailable, showOnMobile }) => {
  const classes = useStyles({ showOnMobile });
  return (
    <Box className={classes.mainStyles}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          {quoteUnavailable && (
            <Box>
              <Typography variant="h2" align="center">
                Fare available over the phone only
              </Typography>
            </Box>)}
          {quoteUnavailable && (<Box mb={1.5}>
              <Typography variant="body1" align="center">
                Please contact your agent
              </Typography>
            </Box>)}
          <OperatorStatus
            logoSrc={operatorInfo?.img || OperatorIcon}
            status={operatorInfo?.online}
          />
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            {operatorInfo?.phone && (
              <a
                href={`tel:${operatorInfo?.phone}`}
                className={classes.telLink}
              >
                <img src={PhoneIcon} alt="phone" />
                <Typography variant="h4" color="textPrimary">
                  {operatorInfo?.phone}
                </Typography>
              </a>
            )}
            <Box mb={1.5}>
              <a
                href={`mailto:${operatorInfo?.email}`}
                className={classes.blueLink}
              >
                <Typography color="textPrimary">
                  {operatorInfo?.email}
                </Typography>
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
      <Typography variant="body1" align="center">
        If you have any questions, please don’t hesitate to contact your agent.
      </Typography>
    </Box>
  );
};

export default FormOperator;
